<div class="position-relative h-100 d-flex flex-column">
  <app-section-loader [loading]="loading"></app-section-loader>
  <div class="scroll page-bg flex-fill overflow-auto py-3 px-5 centerform">
    <div class="container p-0">
      <form [formGroup]="updateLessonForm" [class.lesson-validation-flash]="validationFlash" (ngSubmit)="updateLesson(updateLessonForm.value)">
        <div class="mControls">
          <div class="input-group mr-auto">
            <h1 class="m-0 text-white align-items-center d-inline-flex">
              {{editLesson? 'Update Lesson Plan ' + lessonToEdit?.lesson_plan_number + ' Guide' : 'Create New Lesson Plan'}}
            </h1>
          </div>
          <div class="mControls__right">
            <div class="input-group">
              <button type="button" mat-raised-button (click)="navigateBack()">
                Cancel
              </button>
            </div>
            <div class="input-group">
              <button mat-raised-button color="primary">
                {{ this.lessonId ? 'Update' : 'Done' }}
              </button>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12 mb-3">
            <div class="card">
              <div class="card-header">General 11 </div>
              <div class="card-body">
                <div class="row">
                  <div class="col-6">
                    <mat-form-field appearance="outline" class="w-100">
                      <mat-label>Lesson Plan Number</mat-label>
                      <input type="text" inputmode="numeric" pattern="[0-9]*" placeholder="Lesson Plan Number" matInput
                        name="lessonPlanNumber" id="lessonPlanNumber" formControlName="lesson_plan_number" required
                        (input)="numbersOnly('lesson_plan_number')">
                      <mat-error *ngIf="updateLessonForm.get('lesson_plan_number').hasError('required')">Lesson Number is
                        required</mat-error>
                      <mat-error *ngIf="updateLessonForm.get('lesson_plan_number').hasError('pattern')">Invalid Lesson Number
                      </mat-error>
                    </mat-form-field><br>
                  </div>
                  <div class="col-6">

                    <!-- CREATE MODE -->
                    <mat-form-field *ngIf="!editLesson" appearance="outline" class="w-100">
                      <mat-label>Grade Level</mat-label>

                      <mat-select formControlName="grade_id">
                        <mat-option
                          *ngFor="let grade of allGrades"
                          [value]="grade.id">
                          {{ grade.grade_level }}
                        </mat-option>
                      </mat-select>

                      <mat-error *ngIf="updateLessonForm.get('grade_id').hasError('required')">
                        Grade is required
                      </mat-error>
                    </mat-form-field>

                    <!-- EDIT MODE -->
                    <mat-form-field *ngIf="editLesson" appearance="outline" class="w-100">
                      <mat-label>Grade Level</mat-label>

                      <input
                        matInput
                        [value]="lessonToEdit?.grade_id?.grade_level"
                        readonly>
                    </mat-form-field>

                  </div>
                  <div class="col-6">
                    <mat-form-field appearance="outline" class="w-100">
                      <mat-label>Yearly Plan</mat-label>
                      <mat-select formControlName="curriculum_name" required>
                        <mat-option *ngFor="let c of lessonCurriculumOptions" [value]="c.lesson_plan_curriculum_name || c.curriculum_name">
                          {{ c.lesson_plan_curriculum_name || c.curriculum_name }}
                        </mat-option>
                      </mat-select>
                      <mat-error *ngIf="submitted && updateLessonForm.get('curriculum_name')?.hasError('required')">
                        Yearly Plan is required
                      </mat-error>
                    </mat-form-field>
                  </div>
                  <div class="col-6">
                    <mat-form-field appearance="outline" class="w-100">
                      <mat-label>Lesson Plan Name</mat-label>
                      <input maxlength="100" placeholder="Lesson Plan Name" matInput name="lessonPlanName" id="lessonPlanName"
                        type="text" formControlName="lesson_plan_name" required (keydown)="validateSpace($event, inputName)">
                      <mat-error *ngIf="updateLessonForm.get('lesson_plan_name').hasError('required')">Lesson Plan Name is
                        required</mat-error>
                    </mat-form-field>
                  </div>
                  <div class="col-6">
                    <mat-form-field appearance="outline" class="w-100">
                      <mat-label>Be The Difference</mat-label>
                      <input placeholder="Be The Difference" matInput name="beTheDifference" id="beTheDifference"
                        type="text" formControlName="be_the_difference" required >
                      <mat-error *ngIf="updateLessonForm.get('be_the_difference').hasError('required')">Be The Difference is
                        required</mat-error>
                    </mat-form-field>
                  </div>
                  <div class="col-6">
                    <mat-form-field appearance="outline" class="w-100">
                      <mat-label>UFLI Strategies</mat-label>
                      <input placeholder="UFLI Strategies" matInput name="ufliStratergies" id="ufliStratergies"
                      type="text" formControlName="ufli_strategies" >
                    </mat-form-field>
                  </div>
                  <div class="col-6">
                    <mat-form-field appearance="outline" class="w-100">
                      <mat-label>Easy Read</mat-label>
                      <input  placeholder="Easy Read" matInput name="easyRead" id="easyRead"
                        type="text" formControlName="easy_read" required >
                      <mat-error *ngIf="updateLessonForm.get('easy_read').hasError('required')">Easy Read is
                        required</mat-error>
                    </mat-form-field>
                  </div>
                
                  <div class="col-6">
                    <mat-form-field appearance="outline" class="w-100">
                      <mat-label>Read With</mat-label>
                      <input  placeholder="Read With" matInput name="readWith" id="readWith"
                        type="text" formControlName="read_with" required >
                      <mat-error *ngIf="updateLessonForm.get('read_with').hasError('required')">Read With is
                        required</mat-error>
                    </mat-form-field>
                  </div>
                  <div class="col-6">
                    <mat-form-field appearance="outline" class="w-100">
                      <mat-label>Phonics Lesson</mat-label>
                      <input
                        placeholder="Enter video URL"
                        matInput
                        type="text"
                        formControlName="embedded_video_url">
                      <mat-error *ngIf="updateLessonForm.get('embedded_video_url')?.hasError('pattern')">
                        Invalid video URL
                      </mat-error>
                    </mat-form-field>
                  </div>
                  <div class="col-12">
                    <mat-label>Tutor Tip <span class="required-symbol">*</span></mat-label>
                    <!-- <textarea formControlName="summary" [config]="editorConfig" required></textarea> -->
                     <div class="ck-editor-wrapper" [class.ck-editor-wrapper--invalid]="isTutorTipsInvalid()">
                       <ckeditor
                         [editor]="Editor"
                         (ready)="onEditorReady($event)"
                         formControlName="summary"
                         [config]="ckConfig">
                       </ckeditor>
                     </div>
                     <mat-error *ngIf="isTutorTipsInvalid()">Tutor Tips is required</mat-error>

                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-12 mb-3" formArrayName="passage">
          <div *ngFor="let element of passage.controls; let i = index" [formGroupName]="i" class="passage mb-3">
            <div class="card">
              <div class="card-header d-flex align-items-center justify-content-between">
                <span>Lesson Passage {{ i + 1 }}</span>
                <button *ngIf="lessonId" type="button" mat-icon-button (click)="goToEditPassage(i)" matTooltip="Edit passage">
                  <mat-icon>edit</mat-icon>
                </button>
              </div>
              <div class="card-body">
                <div class="row">

                  <!-- CREATE MODE: curriculum filter + passage dropdown -->
                  <ng-container *ngIf="!lessonId">
                    <div class="col-5" (click)="showLessonGradeRequiredMessage()">
                      <mat-form-field appearance="outline" class="w-100" [class.lesson-required-field--invalid]="isPassageSelectionInvalid(i) && !selectedCurriculum[i]">
                      <mat-label>Curriculum</mat-label>
                      <mat-select [(ngModel)]="selectedCurriculum[i]" [ngModelOptions]="{standalone: true}"
                        (selectionChange)="onCurriculumSelect($event.value, i)" [disabled]="!isLessonGradeSelected()" required>
                          <mat-option *ngIf="isLessonGradeSelected() && !curriculumOptions?.length" disabled class="lesson-dropdown-error">
                            No Curriculum available
                          </mat-option>
                          <mat-option *ngFor="let opt of curriculumOptions" [value]="opt.id">{{ opt.curriculum_name }}</mat-option>
                      </mat-select>
                        <mat-error *ngIf="isPassageSelectionInvalid(i) && !selectedCurriculum[i]">Curriculum is required</mat-error>
                      </mat-form-field>
                    </div>
                    <div class="col-6" (click)="showLessonGradeRequiredMessage()">
                      <mat-form-field appearance="outline" class="w-100" [class.lesson-required-field--invalid]="isPassageSelectionInvalid(i)">
                        <mat-label>Choose Lesson Passage</mat-label>
                        <mat-select [disabled]="!isLessonGradeSelected() || !selectedCurriculum[i]" required>
                          <mat-option *ngIf="isLessonGradeSelected() && selectedCurriculum[i] && !lessonPassagesByCurriculum[i]?.length" disabled class="lesson-dropdown-error">
                            No Passages available
                          </mat-option>
                          <mat-option matNativeControl selected *ngFor="let passages of lessonPassagesByCurriculum[i]" [value]="passages.passage_id" (onSelectionChange)="onPassageSelect($event, passages, i)">
                            {{passages.passage_name}}
                          </mat-option>
                        </mat-select>
                        <mat-error *ngIf="isPassageSelectionInvalid(i)">Lesson Passage is required</mat-error>
                      </mat-form-field>
                    </div>
                  </ng-container>

                  <!-- EDIT MODE: read-only passage display -->
                  <ng-container *ngIf="lessonId">
                    <div class="col-12">
                      <ul class="list-unstyled form-lr">
                        <li>
                          <span class="form-lr__left">Passage Name</span>
                          <span class="form-lr__right">{{ lessonToEdit?.passage?.[i]?.passage_name }}</span>
                        </li>
                        <li>
                          <span class="form-lr__left">Word Count</span>
                          <span class="form-lr__right">{{ lessonToEdit?.passage?.[i]?.word_count }}</span>
                        </li>
                        <li>
                          <span class="form-lr__left">Lesson Passage</span>
                          <div class="form-lr__right" [innerHTML]="lessonToEdit?.passage?.[i]?.passage_summary | safeHtml"></div>
                        </li>
                      </ul>
                    </div>
                    <mat-error class="ck-editor-error"
                      *ngIf="getPassageControl(i).get('passage_summary').invalid && getPassageControl(i).get('passage_summary').touched">
                      Lesson Passage is required
                    </mat-error>
                    <div class="col-12 mt-2" *ngIf="passageImages[i]?.length">
                      <label class="mb-2"><strong>Images</strong></label>
                      <div class="image-preview-grid">
                        <div class="image-preview-item" *ngFor="let image of passageImages[i]">
                          <img [src]="image" alt="Passage image" class="preview-image">
                          <button type="button" class="preview-btn" (click)="previewImage(image); $event.preventDefault(); $event.stopPropagation();">
                            <mat-icon>visibility</mat-icon>
                          </button>
                        </div>
                      </div>
                    </div>
                  </ng-container>

                  <!-- Selected passage details (create mode after choosing) -->
                  <div class="col-12 mt-4" *ngIf="passageDetails[i]">
                    <ul class="list-unstyled form-lr">
                      <li>
                        <span class="form-lr__left">Passage Name</span>
                        <span class="form-lr__right">{{ passageDetails[i].passage_name }}</span>
                      </li>
                      <li>
                        <span class="form-lr__left">Passage Word Count</span>
                        <span class="form-lr__right">{{ passageDetails[i].word_count }}</span>
                      </li>
                      <li>
                        <span class="form-lr__left">Lesson Passage</span>
                        <div [innerHTML]="passageDetails[i]?.passage_summary | safeHtml" class="form-lr__right"></div>
                      </li>
                    </ul>
                  </div>
                  <div class="mt-4" *ngIf="passageDetails[i]">
                    <img
                      *ngIf="images[i]?.length"
                      [src]="images[i][0]?.path || images[i][0]"
                      alt="image"
                      class="hug_sliderimage"
                      style="width: 1100px; max-width: 100%; height: 400px; object-fit: contain; display: block; margin: auto;"
/>
                    <!--
                    <carousel
                      class="hug_sliderimage"
                      cellWidth="100%"
                      objectFit="contain"
                      [height]="400"
                      [width]="1100"
                      [cellsToShow]="1"
                      [images]="images[i]"
                    >
                    </carousel>
                    -->
                  </div>

                </div>
              </div>
            </div>
          </div>
         </div>
      </div>
      </form>
    </div>
  </div>
</div>

<ng-template #imagePreviewDialog>
  <div class="image-preview-dialog">
    <div class="preview-container">
      <img [src]="previewImageUrl" alt="Preview" class="preview-full-image">
      <button class="close-btn" (click)="closePreview()">
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </div>
</ng-template>
